import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=f74f853a&scoped=true"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=f74f853a&prod&scoped=true&lang=css"
import style1 from "./ListProjects.vue?vue&type=style&index=1&id=f74f853a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74f853a",
  null
  
)

export default component.exports